import { Component, ElementRef, HostListener, Inject, Renderer2, ViewChild } from '@angular/core';
import LocomotiveScroll from 'locomotive-scroll';
import { PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser, NgClass, NgStyle } from '@angular/common';
import { TypewriterService } from '../../../core/services/typewriter.service';
import { HomePageServicesComponent } from '../home-page-services/home-page-services.component';
import { WhatWeDoComponent } from '../what-we-do/what-we-do.component';
import { PortfolioComponent } from '../portfolio/portfolio.component';
import { HomePageBlogComponent } from '../home-page-blog/home-page-blog.component';
import { ContactComponent } from '../contact/contact.component';
import { RouteService } from '../../../core/services/route.service';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-home',
  standalone: true,
  imports: [
    HomePageServicesComponent,
    WhatWeDoComponent,
    PortfolioComponent,
    HomePageBlogComponent,
    ContactComponent,
    RouterModule,
  ],
  templateUrl: './home.component.html',
  styleUrl: './home.component.scss',
})
export class HomeComponent {
  // rotationDegree = 0;

  // @HostListener('window:scroll', [])
  // onWindowScroll() {
  //   const maxScroll = document.documentElement.scrollHeight - window.innerHeight;
  //   const scrollPosition = window.scrollX || document.documentElement.scrollLeft;

  //   // Calculate the rotation based on the scroll position (0 to 90 degrees)
  //   this.rotationDegree = (scrollPosition / maxScroll) * 90;
  // }
  @ViewChild('typewriter', { static: true }) typewriterElement!: ElementRef;
  @ViewChild('scrollButton', { static: false }) scrollButton!: ElementRef;

  isBrowser: any;
  private scroll: LocomotiveScroll | undefined;
  scrollProgress = 0;
  scrollBtn: any = '#about';

  constructor(
    @Inject(PLATFORM_ID) private platformId: Object,
    private typewriterService: TypewriterService,
    private renderer: Renderer2,
    private routeService: RouteService
  ) {
    this.isBrowser = isPlatformBrowser(this.platformId);
  }

  ngAfterViewInit() {
    const dataText = ['Websites.', 'Platforms.', 'Startups.', 'Apps.', 'Solutions.'];
    this.typewriterService.startTextAnimation(0, dataText, this.typewriterElement.nativeElement);
    this.initializeScroll();
  }

  private initializeScroll() {
    if (this.isBrowser) {
      const element = document.querySelector('[data-scroll-container]') as HTMLElement;
      const direction = window.innerWidth <= 1024 ? 'vertical' : 'horizontal';

      this.scroll = new LocomotiveScroll({
        el: element,
        smooth: true,
        direction: direction,
        // smartphone: { smooth: true },
      });

      this.scroll.update();
      this.scroll.on('scroll', (args: any) => {
        this.handleScroll(args.scroll.x);
        const { scroll, limit } = args;
        this.scrollProgress = (scroll.x / limit.x) * 100;
      });
    }
  }

  private handleScroll(scrollY: number) {
    if (scrollY > 50) {
      this.renderer.addClass(this.scrollButton.nativeElement, 'hidden');
    } else {
      this.renderer.removeClass(this.scrollButton.nativeElement, 'hidden');
    }
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: Event) {
    if (this.isBrowser) {
      if (this.scroll) {
        this.scroll.destroy();
      }
      this.initializeScroll();
    }
  }

  selectTab(tab: string) {
    this.routeService.setSelectedTab(tab);
  }
}
